import {closeSQFTTool} from "../helpers/sqftHelperUi";
import {getFeatureUrl} from "../../look/lookNavigation/lookFunctions2";
import {clearAllMenusEvents} from "../components/canvas/core/workspace/workspaceEvents";
import Analytics from "../../../analytics";
import isObject from "lodash/isObject";
import {SQFT_FEATURES} from "../constants";
import {IS_LIXIL_UI} from "../../../config";
import {isFirefox} from "../../../misc/helpers";
import {setShowAddedToTheCartSuccess} from "../../../actions/groheFunctions";
import {setSqftFromFeature} from "../../../actions/sqftFunctions";
import {setCameFromPage} from "../../../actions/actionFunctions";
import {useChangeWizardStepRoute} from "../../qkbPages/materialsWizard/useChangeWizardStepRoute";
import {useHistory} from "react-router-dom";
import store from "../../../store";

export const useCloseSQFTCalc = () => {
  const {changeWizardStepRoute} = useChangeWizardStepRoute();
  const history = useHistory();
  const state = store.getState();
  const {cameFromPage} = state.cartState

  const closeLixilUi = (cameFromPage, shouldChangeWizardToNextStep) => {
    closeSQFTTool(cameFromPage, shouldChangeWizardToNextStep, changeWizardStepRoute);
    const {wizardIsActive} = store.getState().wizardState;

    if (!wizardIsActive) {
      window.setTimeout(() => {
        store.dispatch(setShowAddedToTheCartSuccess(true));
      }, 300)
      history.push(getFeatureUrl(cameFromPage));
      history.push(`/cart`);
    }
  }

  const closeSQFTCalc = (shouldChangeWizardToNextStep = true) => {
    // if (payload && payload.measureUnit) {
    //   props.setSqftMeasureUnit(payload.measureUnit);
    // }
    //this.sendPostMessageToSqft(SQFT_POST_MESSAGE_ACTIONS.stopRender);

    clearAllMenusEvents();
    Analytics.sendClickEvent('sqft-close');
    store.dispatch(setSqftFromFeature(null));

    const leaveSqft = () => {
      if (isObject(cameFromPage) && cameFromPage.partId && cameFromPage.partId !== SQFT_FEATURES.slabs) {
        if (IS_LIXIL_UI) {
          closeLixilUi(cameFromPage, shouldChangeWizardToNextStep)
        } else {
          closeSQFTTool("materials", shouldChangeWizardToNextStep, changeWizardStepRoute);
        }
        //props.toggleSelectionFeatureInfo(cameFromPage);
      } else {
        const redirectToPage = cameFromPage && cameFromPage !== "sqft" ? cameFromPage : "materials"
        closeSQFTTool(redirectToPage, shouldChangeWizardToNextStep, changeWizardStepRoute);
      }
      store.dispatch(setCameFromPage("sqft"));
    };

    if (isFirefox()) {
      setTimeout(() => {
        leaveSqft();
      }, 0)
    } else {
      leaveSqft();
    }
  }

  return {closeSQFTCalc}
};
